import { render, staticRenderFns } from "./FormControlCoursesDatesBookings.vue?vue&type=template&id=596d2ffc"
import script from "./FormControlCoursesDatesBookings.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlCoursesDatesBookings.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports